(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["merklinger-eventkalender"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('merklinger-event-calendar')) return;
  const iso = date => date.toISOString().slice(0, 10);
  function parseDate(value) {
    if (!/^\d{4}-\d{2}-\d{2}$/.test(value || '')) return null;
    const date = new Date(`${value}T00:00:00Z`);
    return Number.isFinite(date.getTime()) && iso(date) === value ? date : null;
  }
  function parseTime(value) {
    if (!value) return null;
    if (!/^(?:[01]\d|2[0-3]):[0-5]\d$/.test(value)) return NaN;
    const [hour, minute] = value.split(':').map(Number);
    return hour * 60 + minute;
  }
  function localNow() {
    const parts = Object.fromEntries(new Intl.DateTimeFormat('en-CA', { timeZone: 'Europe/Berlin', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hourCycle: 'h23' }).formatToParts(new Date()).map(part => [part.type, part.value]));
    return { date: `${parts.year}-${parts.month}-${parts.day}`, minutes: Number(parts.hour) * 60 + Number(parts.minute) };
  }

  class MerklingerEventCalendar extends HTMLElement {
    connectedCallback() { this.frame = requestAnimationFrame(() => this.init()); }

    init() {
      if (!this.isConnected || this.initialized) return;
      this.initialized = true;
      this.editor = this.dataset.editor === 'true';
      this.locale = this.dataset.locale || 'de';
      try { new Intl.DateTimeFormat(this.locale); } catch (_) { this.locale = 'de'; }
      this.format = (date, options) => new Intl.DateTimeFormat(this.locale, { timeZone: 'UTC', ...options }).format(date);
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.querySelectorAll('.mkcal-event-image').forEach(image => {
        const hideFailedImage = () => { image.closest('[data-event-media]').hidden = true; };
        image.addEventListener('error', hideFailedImage, { signal });
        if (image.complete && image.naturalWidth === 0) hideFailedImage();
      });
      this.category = 'all';
      this.selected = null;
      this.forcedBlock = null;
      this.view = window.matchMedia('(max-width: 599px)').matches ? this.dataset.mobileView : this.dataset.defaultView;
      this.view = this.view === 'list' ? 'list' : 'month';
      this.records = Array.from(this.querySelectorAll('[data-event]')).map(node => {
        const start = parseDate(node.dataset.date);
        const end = parseDate(node.dataset.endDate || node.dataset.date);
        const from = parseTime(node.dataset.startTime);
        const until = parseTime(node.dataset.endTime);
        const valid = Boolean(start && end && end >= start && !Number.isNaN(from) && !Number.isNaN(until) && (until === null || from !== null) && !(start?.getTime() === end?.getTime() && from !== null && until !== null && until <= from));
        if (valid) {
          node.querySelector('[data-date-label]').textContent = this.format(start, { weekday: 'short', day: 'numeric', month: 'long', year: 'numeric' }) + (iso(end) !== iso(start) ? ` – ${this.format(end, { day: 'numeric', month: 'long', year: 'numeric' })}` : '');
          node.querySelector('.mkcal-date-badge span').textContent = this.format(start, { month: 'short' }).replace('.', '');
        }
        return { node, id: node.dataset.blockId, start, end, from, until, valid, enabled: node.dataset.enabled === 'true', category: node.dataset.category, title: node.dataset.title, short: node.dataset.shortTitle };
      }).sort((a, b) => (a.start?.getTime() ?? Infinity) - (b.start?.getTime() ?? Infinity) || (a.from ?? 0) - (b.from ?? 0));
      const cards = this.querySelector('[data-cards]');
      this.records.forEach(record => cards.appendChild(record.node));
      this.now = localNow();
      const active = this.activeRecords();
      const fallbackMonth = active[0] && iso(active[0].start) > this.now.date ? iso(active[0].start).slice(0, 7) : this.now.date.slice(0, 7);
      this.month = parseDate(`${this.dataset.initialMonth}-01`) || parseDate(`${fallbackMonth}-01`);
      const weekdays = this.querySelector('[data-weekdays]');
      weekdays.replaceChildren();
      for (let i = 0; i < 7; i++) {
        const date = new Date(Date.UTC(2026, 0, 5 + i));
        const th = document.createElement('th');
        th.scope = 'col';
        th.textContent = this.format(date, { weekday: 'short' });
        th.setAttribute('aria-label', this.format(date, { weekday: 'long' }));
        weekdays.appendChild(th);
      }
      this.addEventListener('click', event => {
        const button = event.target.closest('button');
        if (!button || !this.contains(button)) return;
        if (button.dataset.category) { this.category = button.dataset.category; this.forcedBlock = null; }
        else if (button.dataset.view) { this.view = button.dataset.view; this.forcedBlock = null; }
        else if (button.dataset.step) { this.month.setUTCMonth(this.month.getUTCMonth() + Number(button.dataset.step)); this.selected = null; this.forcedBlock = null; }
        else if (button.hasAttribute('data-today')) { this.now = localNow(); this.month = parseDate(`${this.now.date.slice(0, 7)}-01`); this.selected = null; this.forcedBlock = null; }
        else if (button.hasAttribute('data-reset')) { this.selected = null; this.forcedBlock = null; }
        else if (button.dataset.day) { this.selected = this.selected === button.dataset.day ? null : button.dataset.day; this.forcedBlock = null; }
        else return;
        const focusDay = button.dataset.day;
        this.render();
        if (focusDay) this.querySelector(`[data-day="${focusDay}"]`)?.focus({ preventScroll: true });
      }, { signal });
      this.querySelector('[data-days]').addEventListener('keydown', event => this.navigateDay(event), { signal });
      document.addEventListener('visibilitychange', () => { if (!document.hidden) this.render(); }, { signal });
      window.addEventListener('pageshow', () => this.render(), { signal });
      document.addEventListener('shopify:block:select', event => {
        const record = this.records.find(item => item.id === event.detail.blockId);
        if (!record) return;
        this.forcedBlock = record.id;
        this.category = 'all';
        this.view = 'month';
        if (record.start) { this.month = parseDate(`${iso(record.start).slice(0, 7)}-01`); this.selected = iso(record.start); }
        this.render();
        record.node.scrollIntoView({ block: 'nearest', behavior: 'auto' });
      }, { signal });
      document.addEventListener('shopify:section:unload', event => { if (event.detail.sectionId === this.dataset.sectionId) this.destroy(); }, { signal });
      this.querySelector('[data-controls]').hidden = false;
      this.dataset.ready = 'true';
      this.render();
      this.tick();
    }

    activeRecords() {
      return this.records.filter(record => {
        if (!record.valid || !record.enabled) return false;
        if (this.dataset.hidePast !== 'true') return true;
        const end = iso(record.end);
        return end > this.now.date || (end === this.now.date && (record.until === null || record.until > this.now.minutes));
      });
    }

    render() {
      if (!this.initialized || !this.month) return;
      this.now = localNow();
      const active = this.activeRecords();
      const filtered = active.filter(record => this.category === 'all' || record.category === this.category);
      const start = iso(this.month);
      const monthEnd = iso(new Date(Date.UTC(this.month.getUTCFullYear(), this.month.getUTCMonth() + 1, 0)));
      const selectedDate = this.selected;
      const visible = filtered.filter(record => {
        if (this.view === 'list') return true;
        return selectedDate ? iso(record.start) <= selectedDate && iso(record.end) >= selectedDate : iso(record.start) <= monthEnd && iso(record.end) >= start;
      });
      for (const record of this.records) {
        const force = this.editor && this.forcedBlock === record.id;
        record.node.hidden = !visible.includes(record) && !force;
        const warning = record.node.querySelector('[data-event-warning]');
        if (warning) {
          warning.hidden = record.valid && record.enabled;
          warning.textContent = this.dataset.labelInvalid;
        }
      }
      this.dataset.view = this.view;
      this.querySelector('[data-month-panel]').hidden = this.view !== 'month';
      this.querySelectorAll('[data-category]').forEach(node => { if (node.tagName === 'BUTTON') node.setAttribute('aria-pressed', String(node.dataset.category === this.category)); });
      this.querySelectorAll('[data-view]').forEach(node => node.setAttribute('aria-pressed', String(node.dataset.view === this.view)));
      this.querySelector('[data-month-heading]').textContent = this.format(this.month, { month: 'long', year: 'numeric' });
      this.querySelector('[data-agenda-heading]').textContent = this.view === 'list' ? this.dataset.labelAll : selectedDate ? this.format(parseDate(selectedDate), { weekday: 'long', day: 'numeric', month: 'long' }) : this.dataset.labelMonth;
      this.querySelector('[data-reset]').hidden = this.view === 'list' || !selectedDate;
      this.querySelector('[data-count]').textContent = `${visible.length} ${visible.length === 1 ? this.dataset.labelEvent : this.dataset.labelEvents}`;
      this.querySelector('[data-empty]').hidden = visible.length > 0 || Boolean(this.editor && this.forcedBlock);
      const total = this.querySelector('[data-total]');
      total.textContent = `${active.length} ${active.length === 1 ? this.dataset.labelEvent : this.dataset.labelEvents}`;
      total.hidden = false;
      this.renderGrid(filtered);
    }

    renderGrid(records) {
      const grid = this.querySelector('[data-days]');
      const focusDate = this.contains(document.activeElement) ? document.activeElement?.dataset?.day : null;
      grid.replaceChildren();
      const firstOffset = (this.month.getUTCDay() + 6) % 7;
      const monthDays = new Date(Date.UTC(this.month.getUTCFullYear(), this.month.getUTCMonth() + 1, 0)).getUTCDate();
      const cells = Math.ceil((firstOffset + monthDays) / 7) * 7;
      let row;
      for (let index = 0; index < cells; index++) {
        if (index % 7 === 0) { row = document.createElement('tr'); grid.appendChild(row); }
        const cell = document.createElement('td');
        row.appendChild(cell);
        const day = index - firstOffset + 1;
        if (day < 1 || day > monthDays) { cell.className = 'mkcal-other-month'; continue; }
        const date = new Date(Date.UTC(this.month.getUTCFullYear(), this.month.getUTCMonth(), day));
        const dateString = iso(date);
        const dayEvents = records.filter(record => iso(record.start) <= dateString && iso(record.end) >= dateString);
        const button = document.createElement('button');
        button.type = 'button'; button.className = 'mkcal-day'; button.dataset.day = dateString;
        button.setAttribute('aria-pressed', String(this.selected === dateString));
        button.setAttribute('aria-label', `${this.format(date, { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' })}: ${dayEvents.length} ${dayEvents.length === 1 ? this.dataset.labelEvent : this.dataset.labelEvents}${dayEvents.length ? '. ' + dayEvents.map(event => event.title).join('; ') : ''}`);
        if (dateString === this.now.date) button.setAttribute('aria-current', 'date');
        const number = document.createElement('strong'); number.textContent = String(day); button.appendChild(number);
        for (const event of dayEvents.slice(0, 2)) {
          const label = document.createElement('span'); label.className = `mkcal-day-label mkcal-day-label--${event.category}`; label.textContent = event.short; label.setAttribute('aria-hidden', 'true'); button.appendChild(label);
        }
        if (dayEvents.length > 2) { const more = document.createElement('span'); more.className = 'mkcal-day-label'; more.textContent = `+${dayEvents.length - 2}`; more.setAttribute('aria-hidden', 'true'); button.appendChild(more); }
        const dots = document.createElement('span'); dots.className = 'mkcal-day-dots'; dots.setAttribute('aria-hidden', 'true');
        for (const category of new Set(dayEvents.map(event => event.category))) { const dot = document.createElement('i'); dot.className = `mkcal-dot mkcal-dot--${category}`; dots.appendChild(dot); }
        button.appendChild(dots); cell.appendChild(button);
      }
      if (focusDate) this.querySelector(`[data-day="${focusDate}"]`)?.focus({ preventScroll: true });
    }

    navigateDay(event) {
      const target = event.target.closest('[data-day]');
      if (!target) return;
      const date = parseDate(target.dataset.day);
      const offset = { ArrowLeft: -1, ArrowRight: 1, ArrowUp: -7, ArrowDown: 7 }[event.key];
      if (offset === undefined && !['Home', 'End'].includes(event.key)) return;
      event.preventDefault();
      const weekday = (date.getUTCDay() + 6) % 7;
      date.setUTCDate(date.getUTCDate() + (offset ?? (event.key === 'Home' ? -weekday : 6 - weekday)));
      const nextMonth = iso(date).slice(0, 7);
      if (nextMonth !== iso(this.month).slice(0, 7)) { this.month = parseDate(`${nextMonth}-01`); this.selected = null; this.render(); }
      this.querySelector(`[data-day="${iso(date)}"]`)?.focus({ preventScroll: true });
    }

    tick() {
      this.timer = setTimeout(() => { this.render(); this.tick(); }, 60000 - Date.now() % 60000 + 10);
    }

    destroy() {
      cancelAnimationFrame(this.frame); clearTimeout(this.timer); this.controller?.abort(); this.initialized = false;
    }

    disconnectedCallback() { this.destroy(); }
  }

  customElements.define('merklinger-event-calendar', MerklingerEventCalendar);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shopify-angebots-popup"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('merklinger-event-popup')) return;

  const memory = new Map();
  const opened = new Set();
  const navigationListeners = new Set();
  let hadScrollLock = false;
  let historyCleanup;

  function storage(type, key, value) {
    const fallbackKey = `${type}:${key}`;
    try {
      if (value !== undefined) window[type].setItem(key, value);
      else return window[type].getItem(key) ?? memory.get(fallbackKey) ?? null;
    } catch (_) {
      if (value === undefined) return memory.get(fallbackKey) ?? null;
    }
    memory.set(fallbackKey, value);
  }

  function watchNavigation(callback) {
    navigationListeners.add(callback);
    if (!historyCleanup) {
      const notify = () => navigationListeners.forEach(fn => fn());
      const originals = {};
      const wrappers = {};
      for (const method of ['pushState', 'replaceState']) {
        originals[method] = history[method];
        wrappers[method] = function (...args) {
          const result = originals[method].apply(this, args);
          notify();
          return result;
        };
        history[method] = wrappers[method];
      }
      window.addEventListener('popstate', notify);
      historyCleanup = () => {
        window.removeEventListener('popstate', notify);
        for (const method of ['pushState', 'replaceState']) {
          if (history[method] === wrappers[method]) history[method] = originals[method];
        }
      };
    }
    return () => {
      navigationListeners.delete(callback);
      if (!navigationListeners.size && historyCleanup) {
        historyCleanup();
        historyCleanup = undefined;
      }
    };
  }

  function parseDate(value) {
    if (!/^\d{4}-\d{2}-\d{2}$/.test(value || '')) return null;
    const date = new Date(`${value}T00:00:00Z`);
    return Number.isFinite(date.getTime()) && date.toISOString().slice(0, 10) === value ? date : null;
  }

  function minutes(value) {
    if (!/^(?:[01]\d|2[0-3]):[0-5]\d$/.test(value || '')) return null;
    const [hours, mins] = value.split(':').map(Number);
    return hours * 60 + mins;
  }

  function eventSchedule(config, now = new Date()) {
    const end = parseDate(config.endDate);
    const hasFirst = config.mode === 'weekly' && Boolean(config.startDate);
    const first = hasFirst ? parseDate(config.startDate) : null;
    const startMinutes = minutes(config.startTime);
    const endMinutes = minutes(config.endTime);
    if (!end || (hasFirst && !first) || (first && first > end) || startMinutes === null || endMinutes === null || endMinutes <= startMinutes || !config.timezone) return { error: true };
    if (!['weekly', 'single'].includes(config.mode) || (config.mode === 'weekly' && !/^[0-6]$/.test(config.weekday))) return { error: true };
    let parts;
    try {
      parts = Object.fromEntries(new Intl.DateTimeFormat('en-CA', {
        timeZone: config.timezone, year: 'numeric', month: '2-digit', day: '2-digit',
        hour: '2-digit', minute: '2-digit', hourCycle: 'h23'
      }).formatToParts(now).map(part => [part.type, part.value]));
    } catch (_) { return { error: true }; }
    const today = `${parts.year}-${parts.month}-${parts.day}`;
    const todayDate = parseDate(today);
    const currentMinutes = Number(parts.hour) * 60 + Number(parts.minute);
    let candidate = config.mode === 'single' ? new Date(end) : new Date(first && first > todayDate ? first : todayDate);
    if (config.mode === 'weekly') {
      candidate.setUTCDate(candidate.getUTCDate() + (Number(config.weekday) - candidate.getUTCDay() + 7) % 7);
      if (candidate.toISOString().slice(0, 10) === today && currentMinutes >= endMinutes) candidate.setUTCDate(candidate.getUTCDate() + 7);
    }
    const date = candidate.toISOString().slice(0, 10);
    const expired = candidate > end || date < today || (date === today && currentMinutes >= endMinutes);
    return { date: expired ? null : date, today, live: date === today && currentMinutes >= startMinutes && currentMinutes < endMinutes, error: false };
  }

  class MerklingerEventPopup extends HTMLElement {
    connectedCallback() {
      this.frame = requestAnimationFrame(() => this.init());
    }

    init() {
      if (this.initialized || !this.isConnected) return;
      this.initialized = true;
      this.editor = this.dataset.editor === 'true';
      this.dialog = this.querySelector('dialog');
      this.editorStatus = this.querySelector('[data-editor-status]');
      if (this.dataset.enabled !== 'true' || !this.dialog) return;
      this.config = { mode: this.dataset.mode, weekday: this.dataset.weekday, startDate: this.dataset.startDate, endDate: this.dataset.endDate, startTime: this.dataset.startTime, endTime: this.dataset.endTime, timezone: this.dataset.timezone };
      this.key = `merklinger-event-v1:${this.dataset.sectionId}:${JSON.stringify([this.dataset.eventKey, this.dataset.eventTitle, this.config])}`;
      this.urlKey = `${this.key}:url`;
      this.frequency = this.dataset.frequency || 'session';
      this.delay = Math.max(0, Number(this.dataset.delay) || 0);
      this.media = window.matchMedia('(max-width: 749px)');
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.querySelectorAll('[data-event-close]').forEach(button => button.addEventListener('click', () => this.close(), { signal }));
      this.dialog.addEventListener('close', () => this.release(), { signal });
      this.dialog.addEventListener('cancel', event => { event.preventDefault(); this.close(); }, { signal });
      this.dialog.addEventListener('keydown', event => {
        if (event.key !== 'Tab') return;
        const focusable = Array.from(this.dialog.querySelectorAll('button:not([disabled]), a[href], [tabindex="0"]')).filter(node => node.getClientRects().length);
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last?.focus(); }
        else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first?.focus(); }
      }, { signal });
      const outside = event => {
        const rect = this.dialog.getBoundingClientRect();
        return event.target === this.dialog && (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom);
      };
      this.dialog.addEventListener('pointerdown', event => { this.backdropStart = outside(event); }, { signal });
      this.dialog.addEventListener('click', event => { if (this.backdropStart && outside(event)) this.close(); this.backdropStart = false; }, { signal });
      this.media.addEventListener('change', () => {
        if (!this.mobileAllowed() && this.dialog.open) this.close();
        else if (this.mobileAllowed() && this.pending) this.scheduleOpen();
      }, { signal });
      document.addEventListener('visibilitychange', () => {
        if (!document.hidden && this.refresh() && this.pending) this.scheduleOpen();
      }, { signal });
      document.addEventListener('shopify:section:select', event => {
        if (event.detail.sectionId === this.dataset.sectionId) this.open();
      }, { signal });
      document.addEventListener('shopify:section:unload', event => {
        if (event.detail.sectionId === this.dataset.sectionId) this.destroy();
      }, { signal });
      window.addEventListener('pageshow', event => {
        this.refresh();
        if (!event.persisted || this.editor) return;
        if (this.frequency === 'pageview') this.scheduleOpen();
        if (this.frequency === 'pagechange') this.navigation();
      }, { signal });
      if (!this.refresh()) return;
      this.tick();
      if (this.editor) this.open();
      else if (this.frequency === 'pagechange') {
        this.navigation();
        this.stopNavigation = watchNavigation(() => this.navigation());
      } else this.scheduleOpen();
    }

    tick() {
      clearTimeout(this.refreshTimer);
      this.refreshTimer = setTimeout(() => {
        if (this.refresh()) {
          if (this.pending && !this.openTimer) this.open();
          this.tick();
        }
      }, 60000 - (Date.now() % 60000) + 10);
    }

    mobileAllowed() { return this.editor || this.dataset.mobileEnabled === 'true' || !this.media.matches; }

    refresh() {
      this.state = eventSchedule(this.config);
      if (this.state.error || !this.state.date) {
        this.close();
        clearTimeout(this.openTimer);
        if (this.editorStatus) this.editorStatus.textContent = this.state.error
          ? 'Event-Popup: Bitte Datum (JJJJ-MM-TT), Uhrzeit (HH:MM), Zeitzone und Reihenfolge prüfen. Ende muss nach Beginn liegen.'
          : 'Event-Popup: Die Veranstaltungsreihe ist beendet. Für ein neues Event die Termindaten aktualisieren.';
        return false;
      }
      const date = parseDate(this.state.date);
      const label = this.state.live ? this.dataset.labelLive : this.state.date === this.state.today ? this.dataset.labelToday : this.dataset.labelNext;
      this.querySelector('[data-event-status]').textContent = label;
      const dateNode = this.querySelector('[data-event-date]');
      dateNode.textContent = new Intl.DateTimeFormat('de-DE', { timeZone: 'UTC', day: 'numeric', month: 'long', year: 'numeric' }).format(date);
      dateNode.dateTime = this.state.date;
      const last = new Intl.DateTimeFormat('de-DE', { timeZone: 'UTC', day: '2-digit', month: '2-digit', year: 'numeric' }).format(parseDate(this.config.endDate));
      const weekday = new Intl.DateTimeFormat('de-DE', { timeZone: 'UTC', weekday: 'long' }).format(date);
      this.querySelector('[data-event-recurrence]').textContent = this.config.mode === 'weekly' ? `${this.dataset.labelWeekly} ${weekday}\n${this.dataset.labelUntil} ${last}` : weekday;
      if (this.editorStatus) this.editorStatus.textContent = 'Event-Popup aktiv. Auswahl der Section öffnet die Vorschau erneut. Die Vorschau speichert keine Besucherhäufigkeit.';
      return true;
    }

    shouldShow() {
      if (this.editor) return true;
      if (this.frequency === 'pageview' || this.frequency === 'pagechange') return true;
      if (this.frequency === 'session') return !storage('sessionStorage', `${this.key}:session`);
      if (this.frequency === 'once') return !storage('localStorage', `${this.key}:once`);
      const last = Number(storage('localStorage', `${this.key}:last`));
      if (!last || !Number.isFinite(last) || last > Date.now()) return true;
      if (this.frequency === 'day') return storage('localStorage', `${this.key}:day`) !== this.state.today;
      return Date.now() - last >= Math.max(1, Number(this.dataset.repeatDays) || 7) * 86400000;
    }

    remember() {
      if (this.editor) return;
      if (this.frequency === 'session') storage('sessionStorage', `${this.key}:session`, '1');
      if (this.frequency === 'once') storage('localStorage', `${this.key}:once`, '1');
      if (this.frequency === 'day' || this.frequency === 'interval') {
        storage('localStorage', `${this.key}:last`, String(Date.now()));
        storage('localStorage', `${this.key}:day`, this.state.today);
      }
    }

    navigation() {
      const current = location.pathname + location.search;
      const previous = storage('sessionStorage', this.urlKey);
      storage('sessionStorage', this.urlKey, current);
      if (previous && previous !== current) this.scheduleOpen();
    }

    scheduleOpen() {
      clearTimeout(this.openTimer);
      this.pending = true;
      this.openTimer = setTimeout(() => { this.openTimer = null; this.open(); }, this.delay);
    }

    open() {
      if (!this.isConnected || this.dataset.enabled !== 'true' || !this.dialog || !this.refresh()) return;
      if (this.dialog.open || !this.shouldShow()) { this.pending = false; return; }
      if (!this.mobileAllowed() || document.hidden || document.querySelector('dialog[open]')) { this.pending = true; return; }
      this.pending = false;
      this.previousFocus = document.activeElement;
      this.dialog.showModal();
      if (!opened.size) hadScrollLock = document.body.classList.contains('kw-event-popup-open');
      opened.add(this);
      document.body.classList.add('kw-event-popup-open');
      this.remember();
    }

    close() {
      this.pending = false;
      if (this.dialog?.open) this.dialog.close();
      this.release();
    }

    release() {
      if (!opened.delete(this)) return;
      if (!opened.size && !hadScrollLock) document.body.classList.remove('kw-event-popup-open');
      if (this.previousFocus?.isConnected && typeof this.previousFocus.focus === 'function') this.previousFocus.focus({ preventScroll: true });
      this.previousFocus = null;
    }

    destroy() {
      cancelAnimationFrame(this.frame);
      clearTimeout(this.openTimer);
      clearTimeout(this.refreshTimer);
      this.close();
      this.controller?.abort();
      this.stopNavigation?.();
      this.stopNavigation = undefined;
      this.initialized = false;
    }

    disconnectedCallback() { this.destroy(); }
  }

  customElements.define('merklinger-event-popup', MerklingerEventPopup);
})();

  } catch(e) { console.error(e); }
})();
})();
